import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { SearchSuggestionsService } from '~content/services/SearchSuggestionsService';

import {
    SetOwnerDialogBody, SetOwnerDialogBodyProps, SetOwnerDialogState
} from '../../app/content/SetOwnerDialog';
import { Messages } from '../../codegen/Localize';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { L10n } from '../../ts/L10n/L10n';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';
import { Databases } from '../resources/Databases';
import { Tables } from '../resources/Tables';

export namespace CatalogChangeContentActions {

  export function confirmChangeContact(externalContentType: string, externalContentItem: IContentInfo): ng.IPromise<IResult> {

    let externalContentService: Databases | Tables;
    if (externalContentType === 'database') {
      externalContentService = Databases;
    } else {
      externalContentService = Tables;
    }

    let currentContactId: string = null;
    if (externalContentItem.contact) {
      currentContactId = externalContentItem.contact.id;
    }

    const modalInstance = openReactActionDialog<SetOwnerDialogBodyProps, SetOwnerDialogState, IResult>({
      title:  Messages.changeContact(),
      bodyComponent: SetOwnerDialogBody,
      initialBodyProps: {
        prompt: Messages.changeContactPrompt({ CONTENT_NAME: L10n.elideIfLong(externalContentItem.name) }),
        showCredentialsWarning: false,
        isAdmin: false,
        isOwner: false,
        getQuery: (matchText: string) => SearchSuggestionsService.usersWithoutGuest(matchText)
      },
      initialDialogState: { targetOwner: null },
      actionName: Messages.changeContactConfirm(),
      action: (_bodyProps: SetOwnerDialogBodyProps, dialogState: SetOwnerDialogState) => {
        return externalContentService.setContact(({
          contactId: dialogState.targetOwner.id,
          contactType: 'User',
          ids: [externalContentItem.vizportalId],
        })).then((result: IResult) => {
          displayToastForResult(result, Messages.changeContactError({ CONTENT_NAME: externalContentItem.name }),
          Messages.changeContactSuccess({ CONTACT_NAME: dialogState.targetOwner.displayName }));
          return result;
        });
      },
      actionDisabled: (_bodyProps: SetOwnerDialogBodyProps, dialogState: SetOwnerDialogState) => dialogState.targetOwner == null || dialogState.targetOwner.id === currentContactId,
      dialogWidth: TabDialogWidth.width500px,
      dismissDialogOnActionFailed: false,
    });

    return modalInstance.result;
  }

  function displayToastForResult(result: IResult, errorMessage: string, successMessage: string): any {
    if (result.errors && result.errors.length > 0) {
      ToasterService.instance.pop({
        type: ToastType.Error,
        text: errorMessage
      });
    } else {
      ToasterService.instance.pop({
        type: ToastType.Info,
        text: successMessage
      });
    }
  }
}
